<template>
    <div>
        <div class="templateBox">
            <div style="display: flex">
                <el-form ref="listArgument" :model="listArgument">
                    <el-form-item prop="keyword">
                        <el-input v-model="listArgument.keyword" placeholder="请输入合同模板名称"></el-input>
                    </el-form-item>
                </el-form>
                <div class="searchBox">
                    <el-button type="primary" @click="searchBtn">搜索</el-button>
                    <el-button @click="clearBtn">清空</el-button>
                </div>
            </div>
                <avue-crud :data="data" :option="option" :page.sync="page" @current-change="changePage" @size-change="sizeChange">
                    <template slot="is_use" slot-scope="scope" >
                        <el-switch
                                v-model="scope.row.is_use"
                                :active-value='1'
                                :inactive-value='2'
                                active-text="禁用"
                                active-color="#3d62f6"
                                inactive-text="启用"
                                inactive-color="#dcdfe6"
                                @change="switchChange(scope.row)" >
                        </el-switch>
                    </template>
                    <template slot="menuBtn" slot-scope="scope">
                        <el-dropdown-item class="pull-down"  @click.native="useBtn(scope.row)" v-if="scope.row.tpl_type==2">使用</el-dropdown-item>
                        <el-dropdown-item class="pull-down"  @click.native="formBtn(scope.row)" v-else>使用</el-dropdown-item>
                        <el-dropdown-item class="pull-down"  @click.native="viewBtn(scope.row)" v-if="scope.row.preview_url">预览</el-dropdown-item>
<!--                        <el-button class="View" v-if="scope.row.has_draft==1" @click="useDraft(scope.row)">使用草稿</el-button>-->
                    </template>
                    <template slot-scope="scope" slot="tpl_type">
                        <span v-if="scope.row.tpl_type==1">表单式</span>
                        <span v-else>预览式</span>
                    </template>
                </avue-crud>
        </div>
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                :close-on-click-modal = "false"
                width="30%">
            <span>您是否要使用该模板</span>
            <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="nextStepBtn" v-loading.fullscreen.lock="fullscreenLoading">确 定</el-button>
                </span>
        </el-dialog>
<!--        使用草稿-->
        <el-dialog
                title="使用草稿模板"
                :visible.sync="draftTemplate"
                :close-on-click-modal ="false"
                width="60%">
            <div class="relation">
                <avue-crud :data="listData" :option="option1" >
                    <template slot-scope="scope" slot="menu">
                        <el-button class="customize" @click="useDraftBtn(scope.row)">使用</el-button>
                        <el-button class="customize" @click="deleteDraftBtn(scope.row)">删除</el-button>
                    </template>
                </avue-crud>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="draftTemplate = false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

    import {
        deleteManuscript,
        draftList,
        fillInTemplate,
        onlineContract,
        switchBtn,
        templateList
    } from '../../api/templateList';

    export default {
        name: 'formwork',
        inject: ['reload'],
        data() {
            return {
                name: '',
                page: {
                    currentPage: 1,
                    total: 20,  //总数
                    pageSize: 10 //每页多少
                },
                listArgument:{
                    limit:10,
                    page:1,
                    keyword:'',
                },
                mode:'',
                pages:1,
                templateId:'',
                dialogVisible:false,       //弹框
                fullscreenLoading:false,  //loading
                draftTemplate:false,
                data: [],
                listData:[],
                id:'',
                option: {
                    menuType: 'menu',
                    menuBtnTitle:'操作',
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:150,  //操作栏宽度设置
                    column: [
                        {
                            label: '模板名称',
                            prop: 'tpl_name'

                        }, {
                            label: '模板类型',
                            prop: 'product_name'

                        }, {
                            label: '平台模板状态',
                            prop: 'status_txt'
                        }, {
                            label: '用户模板状态',
                            prop: 'is_use',
                            slot: true,
                        }, {
                            label: '更新时间',
                            prop: '_update_time'
                        }, {
                            label: '模板类型',
                            prop: 'tpl_type'
                        }
                    ]
                },
                option1:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menuWidth:300,  //操作栏宽度设置
                    column: [
                        {
                            label: '备注',
                            prop: 'notes'
                        },
                        {
                            label: '更新时间',
                            prop: 'update_time'
                        }
                    ]
                }
            };
        },
        methods: {
            //使用
            useBtn(row) {
                this.id=row.id
                if (row.is_use==2){
                    this.$message.error('该模板已被禁用');
                }else {
                    // this.$router.push({path:'/basicInformation',query:{id:row.id}});
                    this.dialogVisible=true
                }
            },
            //分页
            changePage(num) {
                this.listArgument.page = num;
                templateList(this.listArgument).then(res=>{
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                })
                sessionStorage.setItem('formwork',num)
            },
            // 切换每一页条数
            sizeChange(val){
                this.listArgument.page = 1;
                this.listArgument.limit = val;
                sessionStorage.removeItem('formwork')
                this.getList()
            },
            getList(){
                let num = Number(sessionStorage.getItem('formwork'));

                templateList(this.listArgument).then(res=>{
                    if (res.code == 200) {
                        this.data = res.data.list;
                        this.page.total = res.data.count;
                        this.page.currentPage = (this.page.currentPage && num !== 0) ? num : 1;
                    }else {
                        this.$message.error(res.msg);
                    }
                })
            },
            //表单
            formBtn(row){
                this.$router.push({path:'formPage',query:{id:row.id}})
            },
            //切换模板状态
            switchChange(row) {
                switchBtn(row.id,row.is_use).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg);
                        this.reload()
                    }else {
                        this.$message.error(res.msg);
                        this.reload()
                    }
                })
            },
            //确定
            nextStepBtn(){
                this.fullscreenLoading=true
                if (this.mode==1){
                    fillInTemplate(this.id).then(res=>{
                        if (res.code==200){
                            this.fullscreenLoading=false
                            this.dialogVisible=false
                            const link = document.createElement("a"); //自己创建的a标签
                            link.href = res.data.docTemplateFillUrl;
                            // link.target="_blank"
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(res.data.docTemplateFillUrl);
                        }else {
                            this.$message.error(res.msg);
                            this.fullscreenLoading=false
                        }
                    })
                }else {
                    onlineContract(this.id).then(res=>{
                        if (res.code==200){
                            this.fullscreenLoading=false
                            this.dialogVisible=false
                            const link = document.createElement("a"); //自己创建的a标签
                            link.href = res.data.docTemplateFillUrl;
                            // link.target="_blank"
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(res.data.docTemplateFillUrl);
                        }else {
                            this.$message.error(res.msg);
                            this.fullscreenLoading=false
                        }
                    })
                }

            },
            //使用草稿
            useDraft(row){
                this.templateId=row.id
                this.draftTemplate=true
                draftList(row.id).then(res=>{
                    if (res.code==200){
                        this.listData=res.data.list
                    }
                })
            },
            //使用草稿模板
            useDraftBtn(row){
                this.$router.push({path:'/manuscriptPage',query:{id:row.id,templateId:this.templateId}})
            },
            //删除草稿模板
            deleteDraftBtn(row){
                deleteManuscript(row.id).then(res=>{
                    if (res.code==200){
                        this.$message.success(res.msg)
                        this.reload()
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            },
            // 搜索
            searchBtn(){
                sessionStorage.removeItem('formwork')
                this.listArgument.page = 1;
                this.getList();
            },
            // 清空
            clearBtn(){
                this.listArgument.page = 1;
                this.listArgument.limit = 10;
                sessionStorage.removeItem('formwork')
                this.getList()
                this.$refs.listArgument.resetFields();
            },
            //预览
            viewBtn(row){
                window.open(row.preview_url)
            },
        },
        created() {
            this.mode=JSON.parse(sessionStorage.getItem('shenfen')).mode
            let num = Number(sessionStorage.getItem('formwork'));
            if (num == 0){
                this.getList();
            }else {
                this.listArgument.page = num;
                templateList(this.listArgument).then(res=>{
                    this.data = res.data.list;
                    this.page.total = res.data.count;
                    this.page.currentPage = num;
                })
            }

        }
    };
</script>

<style scoped lang="less">
    .templateBox {
        padding: 20px;
        background-color: #fff;
        /*height: 700px;*/
    }
    .View {
        background-color: #3d62f6;
        color: #fff;
    }

    ::v-deep .el-switch__core {
        width: 60px !important;

        height: 24px;
        border-radius: 100px;
        border: none;
    }

    ::v-deep .el-switch__core::after {
        width: 20px;
        height: 20px;
        top: 2px;
    }

    ::v-deep .el-switch.is-checked .el-switch__core::after {
        margin-left: -21px;
    }

    /*关闭时文字位置设置*/
    ::v-deep .el-switch__label--right {
        position: absolute;
        z-index: 1;
        right: 6px;
        margin-left: 0px;
        color: rgba(255, 255, 255, 0.9019607843137255);

    span {
        font-size: 12px;
    }

    }
    /* 激活时另一个文字消失 */
    ::v-deep .el-switch__label.is-active {
        display: none;
    }

    /*开启时文字位置设置*/
    ::v-deep .el-switch__label--left {
        position: absolute;
        z-index: 1;
        left: 5px;
        margin-right: 0px;
        color: rgba(255, 255, 255, 0.9019607843137255);

    span {
        font-size: 12px;
    }

    }
    .customize{
        background-color: #3e62f6;
        color: #fff;
    }
    /deep/.el-dropdown-link {
        cursor: pointer;
        color: #409EFF;
    }
    /deep/.el-icon-arrow-down {
        font-size: 15px;
    }
    .pull-down{
        padding: 5px 30px !important;
    }
    ::v-deep .avue-crud__menu{
        min-height: 0px;
    }
    .searchBox{
        margin-left: 10px;
    }
</style>
